"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blockNamedContexts = blockNamedContexts;
exports.blockVariableInfo = blockVariableInfo;
exports.valueVariableInfo = valueVariableInfo;
var _variables = require("@blockwell/variables");
function valueVariableInfo(cached, ctx, owner, type, val, name) {
  if ((0, _variables.isVarsMetaValue)(val)) {
    val = val.value;
  }
  if (val === null || val === undefined) {
    cached.push({
      path: name.map(it => it.toLowerCase()),
      name: name.join("."),
      type,
      ctx,
      owner,
      valueType: "null"
    });
  } else if (Array.isArray(val)) {
    let joinedName = name.join(".");
    if (joinedName.endsWith(".contract.abi")) {
      // Don't add ABIs from contracts
      return;
    }
    cached.push({
      path: name.map(it => it.toLowerCase()),
      name: joinedName,
      type,
      ctx,
      owner,
      valueType: "array",
      value: val.slice(0, 3).toString() + (val.length > 3 ? " ..." : "")
    });
    valueVariableInfo(cached, ctx, owner, type, val.length, [...name, "length"]);
    let i = 0;
    for (let it of val) {
      valueVariableInfo(cached, ctx, owner, type, it, [...name, i.toString()]);
      ++i;
    }
  } else if (typeof val === "string" || typeof val === "boolean" || typeof val === "number") {
    cached.push({
      path: name.map(it => it.toLowerCase()),
      name: name.join("."),
      type,
      ctx,
      owner,
      valueType: typeof val,
      value: val.toString()
    });
  } else {
    cached.push({
      path: name.map(it => it.toLowerCase()),
      name: name.join("."),
      type,
      ctx,
      owner,
      valueType: "Object"
    });
    for (let [key, it] of Object.entries(val)) {
      valueVariableInfo(cached, ctx, owner, type, it, [...name, key]);
    }
  }
}
function blockVariableInfo(block, types, ownIndex, prepend) {
  var _val$value, _val$value3;
  let known = block.context.knownVariables();
  let cached = [];
  let valueType = (types === null || types === void 0 ? void 0 : types.indexOf("value")) > -1;
  if (prepend) {
    for (let it of prepend) {
      valueVariableInfo(cached, null, it.owner, "value", it.value, [it.name]);
    }
  }
  for (let variable of known) {
    let contractOnly = false;
    let type = variable.type;
    if (types) {
      if (!valueType && !types.includes(type)) {
        continue;
      }
      if (types.length === 1 && types[0] === "contract") {
        contractOnly = true;
      }
    }
    let val = variable.ref.value();
    if (ownIndex && variable.ref instanceof _variables.VariableReference) {
      if (variable.ref.dependsOn(ownIndex)) {
        continue;
      }
    }
    let ctx = variable.ctx;
    let owner = variable.owner;
    let omitTop = false;
    let addValue = (val, name) => {
      valueVariableInfo(cached, ctx, owner, type, val, name);
    };
    switch (val.type) {
      case "value":
        addValue(val.value, [variable.name]);
        break;
      case "nft":
        if (!omitTop) {
          cached.push({
            path: [variable.name.toLowerCase()],
            name: variable.name,
            type,
            ctx,
            owner,
            valueType: "NFT"
          });
        }
        if (val.value) {
          for (let [key, it] of Object.entries(val.value)) {
            addValue(it, [variable.name, key]);
          }
        }
        break;
      case "wallet":
        cached.push({
          path: [variable.name.toLowerCase()],
          name: variable.name,
          type,
          ctx,
          owner,
          valueType: "Wallet",
          value: (_val$value = val.value) === null || _val$value === void 0 ? void 0 : _val$value.address
        });
        break;
      case "contract":
        if (!omitTop) {
          var _val$value2;
          cached.push({
            path: [variable.name.toLowerCase()],
            name: variable.name,
            type,
            ctx,
            owner,
            valueType: "Contract",
            value: (_val$value2 = val.value) === null || _val$value2 === void 0 ? void 0 : _val$value2.name
          });
        }
        if (!contractOnly && val.value) {
          var _val$value$parameters, _val$value$parameters2;
          addValue(val.value.name, [variable.name, "name"]);
          addValue(val.value.address, [variable.name, "address"]);
          addValue(val.value.network, [variable.name, "network"]);
          if ((_val$value$parameters = val.value.parameters) !== null && _val$value$parameters !== void 0 && _val$value$parameters.symbol) {
            addValue(val.value.parameters.symbol, [variable.name, "parameters", "symbol"]);
          }
          if ((_val$value$parameters2 = val.value.parameters) !== null && _val$value$parameters2 !== void 0 && _val$value$parameters2.decimals) {
            addValue(val.value.parameters.decimals, [variable.name, "parameters", "decimals"]);
          }
        }
        break;
      case "dumbapp-result":
        cached.push({
          path: [variable.name.toLowerCase()],
          name: variable.name,
          type,
          ctx,
          owner,
          valueType: "Dumbapp Submission",
          value: (_val$value3 = val.value) === null || _val$value3 === void 0 ? void 0 : _val$value3.toString()
        });
        if (val.value) {
          for (let [key, it] of Object.entries(val.value)) {
            addValue(it, [variable.name, key]);
          }
        }
        break;
      case "null":
        cached.push({
          path: [variable.name.toLowerCase()],
          name: variable.name,
          type,
          ctx,
          owner,
          valueType: "Null"
        });
        break;
    }
  }
  return cached;
}
function blockNamedContexts(block, ownIndex) {
  let parent = block.getParentBlock();
  let contexts = [];
  while (parent) {
    let it = parent;
    parent = parent.getParentBlock();
    if (it.context.name && it.key === it.context.ownerKey) {
      if (ownIndex) {
        if (Array.isArray(ownIndex)) {
          if (ownIndex.includes(it.context.ownerKey)) {
            continue;
          }
        } else if (ownIndex === it.context.ownerKey) {
          continue;
        }
      }
      contexts.push({
        block: it,
        context: it.context,
        name: it.context.name
      });
    }
  }
  return contexts;
}
//# sourceMappingURL=block-utils.js.map